// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as OrderType from "../../../../../library/data-source/order/entity/OrderType.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AdjustFareApiModel from "../api-model/AdjustFareApiModel.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function orderFareApiModelToState(order_fare) {
  return {
          travel_duration: order_fare.travel_duration,
          travel_distance: order_fare.travel_distance,
          waiting_time: order_fare.waiting_time,
          total_restricted_time_mins: order_fare.total_restricted_time_mins,
          toll: Currency.toCurrency(order_fare.toll),
          road_tax: Currency.toCurrency(order_fare.road_tax),
          convenience_charge: Currency.toCurrency(order_fare.convenience_charge),
          incidental_charges: List.map((function (incident) {
                  return {
                          charge_type: {
                            id: incident.charge_type.id,
                            name: incident.charge_type.name
                          },
                          amount: Currency.toCurrency(incident.amount)
                        };
                }), order_fare.incidental_charges),
          fare_without_previous_due: Currency.toCurrency(order_fare.convenience_charge),
          base_fare: Currency.toCurrency(order_fare.base_fare),
          waiting_charge: Currency.toCurrency(order_fare.waiting_charge),
          distance_charge: Currency.toCurrency(order_fare.distance_charge),
          flat_surge: Currency.toCurrency(order_fare.flat_surge),
          travel_duration_charge: Currency.toCurrency(order_fare.travel_duration_charge),
          waypoint_charge: Belt_Option.map(order_fare.waypoint_charge, Currency.toCurrency),
          coupon_discount: Currency.toCurrency(order_fare.coupon_discount),
          vat: Currency.toCurrency(order_fare.vat),
          credit_charge: Currency.toCurrency(order_fare.credit_charge),
          fare: Currency.toCurrency(order_fare.fare),
          cash_back: Currency.toCurrency(order_fare.cash_back),
          fare_after_cashback: Currency.toCurrency(order_fare.fare_after_cashback),
          tax_fares: List.map((function (tax) {
                  return {
                          tax_amount: Currency.toCurrency(tax.tax_amount),
                          tax_name: tax.tax_name
                        };
                }), order_fare.tax_fares),
          total_taxes: Currency.toCurrency(order_fare.total_taxes),
          subscription_discount: Currency.toCurrency(order_fare.subscription_discount)
        };
}

function apiModelToState(res) {
  return {
          data: {
            crn: res.data.crn,
            trip_accepted_time: Timestamp$Catalyst.make(res.data.trip_accepted_time),
            start_time: Timestamp$Catalyst.make(res.data.start_time),
            pickup_time: Timestamp$Catalyst.make(res.data.pickup_time),
            end_time: Timestamp$Catalyst.make(res.data.end_time),
            order_type: OrderType.fromString(res.data.order_type),
            has_fixed_strategy: res.data.has_fixed_strategy,
            is_return_trip: res.data.is_return_trip,
            order_fare: orderFareApiModelToState(res.data.order_fare),
            adjustment_reason: undefined,
            fare_type: /* Current */3
          }
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(AdjustFareApiModel.t_decode(json), "AdjustFareEntityMapper.res"));
}

export {
  orderFareApiModelToState ,
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
